// extracted by mini-css-extract-plugin
export var container = "container-38p";
export var content = "content-s_H";